export const
  FIRST_NAME_FIELD       = 'first_name',
  LAST_NAME_FIELD        = 'last_name',
  SEGMENTS_FIELD         = 'segments',
  EMAIL_FIELD            = 'email',
  LOCATION_FIELD         = 'location',
  PASSWORD_FIELD         = 'password',
  CURRENT_PASSWORD_FIELD = 'current_password',
  NEW_PASSWORD_FIELD     = 'new_password';
